import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_adhcb3vwya: FaireBrandEntity = {
  token: "b_adhcb3vwya",
  type: "brand",
  name: "Hipswan USA Inc.",
  avatarUrl:
    "https://cdn.faire.com/fastly/a73c4f8983dd9611638ceefea8bf328055b243b6ef96d0752fbe2e6f03d3f20a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d2ab0b08260894fe0f496ba09610c16453fd2c2eae657bba431ecf0e15f17a0e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a73c4f8983dd9611638ceefea8bf328055b243b6ef96d0752fbe2e6f03d3f20a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d2ab0b08260894fe0f496ba09610c16453fd2c2eae657bba431ecf0e15f17a0e.png",
  location: "Dover, DE, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "hipSwan launched in 2021 after two years of research and development. hipSwan socks are designed for consumers who support ethical and sustainable brands without compromising on product performance. As of March 2026, we have shipped over 100,000 pairs of socks to 20,000+ happy customers, who have awarded us more than 1,200 5-star reviews. The hipSwan company forest, planted in cooperation with TreeSisters, has grown to over 30,000 trees.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:15.841Z",
    importedBy: "entity-db-cli",
  },
};
